<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
});

const openClass = computed(() => (props.open ? 'config-chevron--open' : ''));
</script>
<template>
  <svg :class="['config-chevron', openClass]" width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M1.35583 0.748535L8.77714 9.13577C8.84045 9.20734 8.93141 9.24832 9.02696 9.24832C9.12251 9.24832 9.21347 9.20734 9.27678 9.13577L16.6988 0.748535" 
    stroke-width="1.25"
    stroke-linecap="round"
  />
  </svg>

</template>

<style>
  .config-chevron--open, .config-chevron {
    cursor: pointer;
    transition: transform 0.1s;
  }

  .config-chevron {
    stroke: var(--color-neutrals-50);
  }

  button:not(:disabled) .config-chevron path {
    stroke-width: 2;
    stroke: var(--color-white);
  }

  .config-chevron--open {
    stroke: var(--color-neutrals-60);
    transform: rotate(180deg) translateY(2px);
  }
</style>
